export const motivosPh3aReceitaEnum = [
  // {descricaoPh3aReceita: "REGULAR", motivo: "Regular", descricaoBanco: "REGULAR"},
  {descricaoPh3aReceita: "PENDENTE DE REGULARIZAÇÃO", motivo: "Pendente de Regularização", descricaoBanco: "PENDENTE_REGULARIZACAO"},
  {descricaoPh3aReceita: "SUSPENSO", motivo: "Suspenso", descricaoBanco: "SUSPENSO"},
  {descricaoPh3aReceita: "CANCELADO", motivo: "Cancelado", descricaoBanco: "CANCELADO"},
  {descricaoPh3aReceita: "NULO", motivo: "Nulo", descricaoBanco: "NULO"},
  {descricaoPh3aReceita: "TITULAR FALECIDO", motivo: "Titular Falecido", descricaoBanco: "TITULAR_FALECIDO" },
  {descricaoPh3aReceita: "", motivo: "Retorno Vazio - PH3A", descricaoBanco: "SEM_RETORNO"}
]
